import { render, staticRenderFns } from "./TrucksOnTheRoad.vue?vue&type=template&id=870fa756&scoped=true"
import script from "./TrucksOnTheRoad.vue?vue&type=script&lang=js"
export * from "./TrucksOnTheRoad.vue?vue&type=script&lang=js"
import style0 from "./TrucksOnTheRoad.vue?vue&type=style&index=0&id=870fa756&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "870fa756",
  null
  
)

export default component.exports